import { UnitsOfLength } from '@race-planner/aws-amplify/src/models';
import {
    convertKilometersToMeters,
    convertMilesToMeters,
    convertMinutesToSeconds,
    convertSecondsToMinutes,
    secondsToTimeSpan
} from '@race-planner/unit-converters';

// Takes a velocity (meters/minutes) and converts it to a VO2 level
const convertVelocityToVO2 = velocity => (
    -4.60 +
    0.182258 * velocity +
    0.000104 * velocity * velocity
);

// Takes a VO2 measurement and converts it to a velocity (meters/minutes)
const convertVO2ToVelocity = vo2 => (
    29.54 +
    5.000663 * vo2 -
    0.007546 * vo2 * vo2
);

// Takes a time in minutes and uses EQ 2 to convert it to a percent of VO2 maximum
const convertTimeInMinutesToPercentVO2Max = minutes => (
    0.8 +
    0.1894393 * Math.exp(-0.012778 * minutes) +
    0.2989558 * Math.exp(-0.1932695 * minutes)
);

const paceUnitConverters = {
    [UnitsOfLength.METRIC]: convertKilometersToMeters,
    [UnitsOfLength.STATUTE]: convertMilesToMeters
};
// Takes a velocity in metres/minute and converts it to a string representing a pace in minutes per mile or km
const convertVelocityToPace = ({ velocity, unitsOfLength }) => {
    const paceInSeconds = convertMinutesToSeconds(paceUnitConverters[unitsOfLength](1 / velocity));
    const { minutes, seconds } = secondsToTimeSpan(Math.floor(paceInSeconds));
    return {
        minutes,
        seconds
    };
};

export const calculateRunTrainingPace = ({
    distanceInMeters,
    timeInSeconds,
    unitsOfLength
}) => {
    const timeInMinutes = convertSecondsToMinutes(timeInSeconds);
    const velocity = distanceInMeters / timeInMinutes;
    const vo2Max = (
        convertVelocityToVO2(velocity) / convertTimeInMinutesToPercentVO2Max(timeInMinutes)
    );
    const easyRunPace = convertVelocityToPace({
        velocity: convertVO2ToVelocity(vo2Max * 0.7),
        unitsOfLength
    });
    const tempoRunPace = convertVelocityToPace({
        velocity: convertVO2ToVelocity(vo2Max * 0.88),
        unitsOfLength
    });
    const vo2MaxRunPace = convertVelocityToPace({
        velocity: convertVO2ToVelocity(vo2Max),
        unitsOfLength
    });
    const speedRunPace = convertVelocityToPace({
        velocity: convertVO2ToVelocity(vo2Max * 1.1),
        unitsOfLength
    });
    const longRunPace = convertVelocityToPace({
        velocity: convertVO2ToVelocity(vo2Max * 0.6),
        unitsOfLength
    });
    const yassoRunPace = convertVelocityToPace({
        velocity: convertVO2ToVelocity(vo2Max) * 1.95,
        unitsOfLength: UnitsOfLength.STATUTE
    });

    return {
        easy: easyRunPace,
        tempo: tempoRunPace,
        vo2Max: vo2MaxRunPace,
        speed: speedRunPace,
        long: longRunPace,
        yasso800Meters: yassoRunPace
    };
};
